import React from "react";
import {FormHelperText} from "@mui/material";
import {ValidatedField} from "../sharedFields/ValidatedField";
import {SecretField} from "../sharedFields/SecretField";
import {isValidSalesforceMyDomain} from "../sharedFields/validationFunctions";
import {DtxSpacer} from "../../../../../components/common/DtxSpacer";

export const sagePeopleDomainHelpText =
  "Your organisation's Salesforce My Domain host, as given by your HR " +
  "Systems team - not login.salesforce.com. Sandbox hosts end in " +
  ".sandbox.my.salesforce.com.";

// Sage People runs on Salesforce. Its consumer key and secret are
// sent as Okta's client ID (tenant_id) and client secret (secret).
export const SagePeople = () => {
  return <>
    <ValidatedField
        valueKey="url"
        label="Salesforce domain"
        placeholder="yourorg.my.salesforce.com"
        errorLabel="A Salesforce domain ending in .my.salesforce.com is required"
        validationFunction={isValidSalesforceMyDomain}
    />
    <FormHelperText sx={{marginLeft: 1.75}}>
      {sagePeopleDomainHelpText}
    </FormHelperText>
    <DtxSpacer space={2} />
    <ValidatedField
        valueKey="tenant_id"
        label="Consumer key"
        placeholder="Consumer key"
        errorLabel="Consumer key required"
    />
    <DtxSpacer space={2} />
    <SecretField
        valueKey="secret"
        placeholder="Consumer secret"
        errorLabel="Consumer secret required"
    />
  </>
};
